import React, { useEffect, useState } from "react";
import { Button, Col, Form, Icon, message, Row, Select } from 'antd';
import { createChatThread } from "../ChatandCall";
import MiCompAPI from "../../../util/api";

function AddParticipantPop(props) {
  const { Option } = Select;
  // const [userId, setUserId] = useState('');
  // const [alternateCallerId, setAlternateCallerId] = useState('');
  const [showAddParticipantPanel, setShowAddParticipantPanel] = useState(false);
  const { getFieldDecorator } = props.form;

  const [state, setState] = useState({
    chattext: "",
    threads: [],
    dthreads: [],
    thread: props.thread,
    messages: [],
    participants: [],
    typingindicator: null,
    readReceipt: '',
    myLastMessage: ""
  })
  const handleSubmit = (e) => {
    e.preventDefault();
    props.form.validateFields((err, values) => {
      AddparticipantsSubmitHandler({ ...values, id: 0 }, (val) => {});
    });
  }
  useEffect(() => {
    getAllContactsofLoggedinUser()
  }, [])

  const userPermandMasters = props.userPermandMasters;
  const api = new MiCompAPI(userPermandMasters);
  const chatThreadClient = null;
  const { UserId, UserProfileName, UserRoleName } = userPermandMasters.decodedToken;
  let { chatClient } = props;
  function getAllContactsofLoggedinUser() {
    api.invoke("getAllContactsofLoggedinUser", "get", (data, success) => {
      if (success) {
        if (data.statusCode === 200) {
          const users = data.data;

          setState({...state, participants: users });
        } else {
          message.destroy();
          message.error(data.statusMessage, 3);
        }
      }
    });
  }

  // function GetallAzureThreads() {
  //   api.invoke("GetallAzureThreads", "get", (data, success) => {
  //     if (success) {
  //       if (data.statusCode === 200) {
  //         setState({...state,
  //           threads: data.data,
  //           dthreads: data.data
  //         });
  //         if (data.data && data.data.length > 0) {
  //           if (state.thread === null) {
  //             setState({...state,
  //               thread: data.data[0],
  //             });
  //             updatechatMessages(data.data[0].threadId);
  //           } else {
  //             setState({...state,
  //               thread: state.thread,
  //               readReceipt: 'sent'
  //             });
  //             updatechatMessages(state.thread.threadId);
  //           }
  //         } else {
  //           setState({...state,
  //             thread: null,
  //             messages: [],
  //           });
  //         }
  //       } else {
  //         message.destroy();
  //         message.error(data.statusMessage, 3);
  //       }
  //     }
  //   });
  // }
  function SaveAzureThreads(data) {
    api.invoke(
      "SaveAzureThreads",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            // GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }
  function AddParticipants(data) {
    api.invoke(
      "AddParticipants",
      "post",
      (data, success) => {
        if (success) {
          if (data.statusCode === 200) {
            // GetallAzureThreads();
          } else {
            message.destroy();
            message.error(data.statusMessage, 3);
          }
        }
      },
      data
    );
  }


  function AddparticipantsCallBack(Users, participants, data, callback) {
    // eslint-disable-next-line array-callback-return
    let { GetUserTokenandIdentitybyId } = props;

    data.forEach((a) => {
      GetUserTokenandIdentitybyId(a, (chatuser) => {
        if (chatuser) {
          let user = state.participants.find((x) => x.userId === a);
          participants.push({
            id: { communicationUserId: chatuser.userIdentity },
            displayName: user && user.name //+ "(" + user.role + ")",
          });
          Users.push({
            userid: user.userId,
            name: user.name,
            role: user.role,
            email: user.email,
            communicationUserId: chatuser.userIdentity,
          });
        }
        return 10;
      });
    });
    callback(Users, participants);
  }
  const AddparticipantsSubmitHandler = (data) => {
    if (state.thread.participants.length === 1) {
      AddparticipantsCallBack(
        [
          {
            userid: UserId,
            name: UserProfileName,
            role: UserRoleName,
            email: props.loginuser.Email,
            communicationUserId: props.loginuser.userIdentity,
          },
          ...state.thread.participants,
        ],
        [
          ...state.thread.participants.map((a) => {
            let user = state.participants.find((x) => x.userId === a.userId);
            return {
              id: { communicationUserId: a.communicationUserId },
              displayName: user && user.name //+ "(" + user.role + ")",

            };
          }),
        ],
        data.participants,
        (Users, participants) => {

          setTimeout(() => {
            createChatThread(
              UserProfileName,
              participants,
              chatClient
            ).then((threadId) => {
              SaveAzureThreads({
                threadId: threadId,
                participants: Users,
              });
            });
          }, 1000);
        }
      );
    } else {
      AddparticipantsCallBack(
        [],
        [],
        data.participants,
        (Users, participants) => {
          setTimeout(() => {
            chatThreadClient
              .addParticipants({ participants: participants })
              .then(() => {
                AddParticipants({
                  threadId: state.thread.threadId,
                  participants: Users,
                });
              });
          }, 1000);
        }
      );
    }
  };

  const updatechatMessages = async (threadId) => {
    setTimeout(async () => {
      chatClient.on("readReceiptReceived", async (e) => {
        setState({...state,
          readReceipt: 'read'
        })
      });
    
      const chatThreadClient = chatClient.getChatThreadClient(threadId);
      const messages = chatThreadClient.listMessages({ maxPageSize: 200 });
      const readreceipts = chatThreadClient.listReadReceipts();
      // for await (const readreceipt of readreceipts.next()) {
      const lastmessageread = await readreceipts.next()

      // }

      const lastMessageDetails = await messages.next()
      if (lastMessageDetails.value.type === 'html' && lastMessageDetails.value.senderDisplayName !== UserProfileName) {
        chatThreadClient.sendReadReceipt({ chatMessageId: lastMessageDetails.value.id })
      }
      for await (const message of messages.byPage()) {
        const readmessage = message.filter(item => item.senderDisplayName === UserProfileName).shift()
        setState({...state,
          messages: [...message],
          readReceipt: readmessage && readmessage.id === lastmessageread.value.chatMessageId ? 'read' : 'sent'
        });
      }
    }, 300);

  };


  // function handleAddCommunicationUser() {
  //     try {
  //         props.call.addParticipant({ communicationUserId: userId });
  //     } catch (e) {
  //         console.error(e);
  //     }
  // }

  // function handleAddPhoneNumber() {
  //     try {
  //         props.call.addParticipant({ phoneNumber: userId }, { alternateCallerId: { phoneNumber: alternateCallerId }});
  //     } catch (e) {
  //         console.error(e);
  //     }
  // }

  function toggleAddParticipantPanel() {
    setShowAddParticipantPanel(!showAddParticipantPanel);
  }
  return (
    <>
      <span><Button href="#" onClick={toggleAddParticipantPanel}><i className="fa fa-plus" aria-hidden="true"></i></Button></span>
      <div className="ms-Grid">
        <div className="ms-Grid-row">
          <div className="ms-Grid-col ms-lg12">
            {
              showAddParticipantPanel &&
              <div className="add-participant-panel">
                <h3 className="add-participant-panel-header">Add a participant</h3>
                <Form onSubmit={handleSubmit} layout="vertical" hideRequiredMark>

                  <Row span={24}>
                    <Col sm={24}>
                      <Form.Item>
                        <fieldset className="mi_input_pop">
                          <legend className="legend-font">Participants</legend>
                          {getFieldDecorator('participants', {
                            rules: [{ required: true, message: 'Please Select Participants.' }],
                          })(<Select
                            suffixIcon={<Icon type="search" />}
                            className="mi_input"
                            optionFilterProp="children"
                            mode='multiple'
                            showSearch={true}
                            filterOption={(input, option) =>
                              option.props.children
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                            }
                            // onChange={ this.GetStatebyLoAState}
                            placeholder="Search"
                          >
                            {state.participants
                              ?
                              state.participants.filter(
                                (x) =>{
                                 return x.userId !== UserId}
                                  //  &&
                                  // !state.thread.participants.find(
                                  //   (a) => a.userid === x.userId
                                  // )
                              ).map((tag) => (
                                <Option value={tag.userId} key={tag.name}>
                                  {tag.name}
                                </Option>
                              ))
                              : ""}
                          </Select>)}
                        </fieldset>
                      </Form.Item>
                    </Col></Row>
                  <Row span={24} style={{ marginTop: '20px' }}>
                    <Col span={7} ></Col>
                    <Col span={5} >
                      <Button htmlType="submit" className="submit-button" type="primary" >
                        Add
                      </Button>
                    </Col>
                  </Row>
                </Form>
              </div>
            }
          </div>
        </div>
      </div>
    </>
  );
}
const AddParticipantPopover = Form.create()(AddParticipantPop);
export default AddParticipantPopover